/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FontSize(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FontSize',
      'aria-hidden': true,
      focusable: false,
      width:  22 * scale,
      height: 14 * scale,
      viewBox: '0 0 22 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M9.2 11.6h1.1l3.6-10.5h1.8l3.6 10.5h1.1v1.3h-3.9v-1.3h1.2L16.8 9h-4l-.9 2.6h1.2v1.3H9.2zm7.2-3.9-1.6-5-1.6 5z"}),createElement('path', {"opacity":".7","fill":"currentColor","d":"M1.5 12.2h.7l2.2-6.1h1.1l2.2 6.1h.7v.8H6v-.8h.8L6.3 11H3.6l-.4 1.2H4v.8H1.5zM6 10.1 5 7l-1.1 3.1z"}))
}
